
import React, {useState} from 'react';

const history = [
    "Gegründet in der Gaststube Bräuner in Opperode am 16.12.1861 vom Gast- und Landwirt Ernst Bräune begeisterte der Chor Handwerker, Gewerbetreibende und Landarbeiter vom Chorgesang. Meist bei Kerzenschein trafen sich am Anfang zwischen 20 und 40 Männer in geselliger Runde zu den Übungsstunden um Ihren Gesang zu festigen.", 

    "Das Singen von deutschen Volksliedern war für viele eine wichtige Abwechslung im harten Dorfalltag. In den vielen Jahren des Männerchores schwankte die Mitgliederzahl zwischen 20 - 60 Männern die 4-stimmig in klassischer Männerchorbesetzung (1. und 2. Tenor sowie 1. und 2. Bass) mit ihren kräftigen Stimmen stets für einen Ohrenschmaus bei vielen Veranstaltungen sorgten. Lediglich in den Kriegsjahren Deutschlands kam der Chor zum Stillstand da viele der Sänger an die Front mussten. Einige kamen nie wieder zurück.",

    "Durch Aufzeichnungen sowie Erzählungen von älteren Mitgliedern des Chores konnte die Geschichte bis heute dargestellt werden, auf die unser Chor sehr stolz ist. Viele Namen müsste man an dieser Stelle erwähnen die für 160-ig Jahre Männerchor Opperode stehen. Unter stabilen, langjährig wirkenden Vorständen, Chorleitern und Sängern erarbeitete sich unser Chor einen angesehenen Platz im Kulturleben der weit über die Grenzen der Stadt Ballenstedt reicht. Das singen von Volksliedern war und ist bis heute eine wichtige Abwechslung im harten Alltag. Gesangsdarbietungen zu Liederabenden, öffentlichen- und privaten Feiern brachten dem Männerchor Anerkennung, Zuspruch und immer wieder junge Sänger ohne die unsere Geschichte schon längst zu Ende wäre.",

    "Die einmal pro Woche stattfindende Singstunde an denen die meisten aktiven Sänger teilnahmen und nehmen sind in den vielen Jahren des Chores nie als Pflicht, sondern aus Überzeugung besucht worden. Denn eins ist sicher,",
    "“Der Männerchor  1861 Opperode e.V. ist das Schönste was unser lieber Herrgott erschaffen hat. Hier ist Mann noch Mann und keine (es sei uns verziehen) Frau kann diesen Bund auseinander bringen. Gesang, Geselligkeit und gesunder Durst das sind die drei G's für die wir stehen!“"
]






function App(props) {  

    return (
        <div className="component-view animate" data-animate="blendin 3s">
       
        
            
                <div className=" text-center text-header">
                    Wir blicken auf 160. Jahre "Opperöder Männerchor"
                </div>

                {
                    history.map(item =>(
                        <div className="text-item text-block" > 
                        {item}
                        </div> 
                    ))
                }

               
            
         
        </div>
    );
}
    
    export default App;